import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const attributesItemStyle = {
  box1: (): SystemStyleObject<Theme> => ({
    display: "flex",
    opacity: "80%",
    alignItems: "center",
  }),
  info: (): SystemStyleObject<Theme> => ({
    fontSize: "20px",
  }),
  info2: (): SystemStyleObject<Theme> => ({
    fontSize: "20px",
    color: " #ECA843",
  }),
  tag: (): SystemStyleObject<Theme> => ({
    fontSize: "18px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: "10px",
    mr: 1,
    padding: 0.5,
  }),
  copyIcon: (): SystemStyleObject<Theme> => ({
    fontSize: "20px",
    color: "rgba(255, 255, 255, 0.8)",
  }),
};

export default attributesItemStyle;
